<ng-template
    class="w-100"
    #titleRef>
    {{ title }}
    @if (tooltip) {
        <nb-icon
            class="icon-info-tooltip"
            [nbPopover]="htmlTip"
            [nbPopoverContext]="{ content: tooltip }"
            nbPopoverTrigger="hover"
            icon="info"
            status="basic"></nb-icon>
    }
</ng-template>
